import { defineQuery, type State, type System } from 'vibegame';
import { completeSequence, playSequence, resetSequence } from 'vibegame/tweening';
import { StepController } from './components';

export type SequenceMap = Record<string, string>;

function calculateMax(map: SequenceMap): number {
  let max = 0;
  for (const key of Object.keys(map)) {
    const [from, to] = key.split('-').map(Number);
    if (!isNaN(from) && !isNaN(to)) {
      max = Math.max(max, from, to);
    }
  }
  return max;
}

function completeAll(state: State, map: SequenceMap): void {
  for (const name of Object.values(map)) {
    const eid = state.getEntityByName(name);
    if (eid !== null) completeSequence(state, eid);
  }
}

const query = defineQuery([StepController]);

export function createSystems(map: SequenceMap): System[] {
  const autoMax = calculateMax(map);

  const InitSystem: System = {
    group: 'setup',
    update(state) {
      for (const eid of query(state.world)) {
        if (StepController.max[eid] === 0) {
          StepController.max[eid] = autoMax;
        }
      }
    },
  };

  const ControllerSystem: System = {
    group: 'simulation',
    update(state) {
      for (const eid of query(state.world)) {
        const current = StepController.step[eid];
        const target = StepController.target[eid];

        if (current !== target) {
          completeAll(state, map);

          const seqName = map[`${current}-${target}`];
          const seq = seqName ? state.getEntityByName(seqName) : null;

          if (seq !== null) {
            resetSequence(state, seq);
            playSequence(state, seq);
          }

          StepController.step[eid] = target;
        }
      }
    },
  };

  return [InitSystem, ControllerSystem];
}
